import * as echarts from "echarts";
// 图表配置项 - 默认选项配置
export const chartOptions = {
  backgroundColor: "transparent",
  grid: {
    left: "4%",
    right: "15%",
    bottom: "5%",
    top: "10%",
    containLabel: true,
  },
  xAxis: {
    data: [],
    axisLine: {
      show: true, //隐藏X轴轴线
      lineStyle: {
        color: "rgba(128, 128, 128, 1)",
        width: 1, //X轴的粗细
      },
    },
    axisTick: {
      show: false, //隐藏X轴刻度
    },
    axisLabel: {
      show: true,
      rotate: 45,
      color: "rgba(128, 128, 128, 1)", //更改坐标轴文字颜色
      fontSize: 14, //更改坐标轴文字大小
    },
  },
  yAxis: [
    {
      type: "value",
      splitLine: {
        show: true,
        Interval: 2,
        lineStyle: {
          color: "rgba(204, 204, 204, 1)", //网格线的颜色
          width: 1, //X轴的粗细
          // type: "dashed", //虚线
        },
      },
      axisTick: {
        show: false,
      },

      axisLine: {
        show: true,
        width: 2, //X轴的粗细
        lineStyle: { color: "rgba(128, 128, 128, 1)" },
      },

      axisLabel: {
        show: true,
        color: "rgba(128, 128, 128, 1)", //更改坐标轴文字颜色
        fontSize: 14, //更改坐标轴文字大小
      },
    },
  ],
  series: [
    {
      name: "",
      type: "line",
      barWidth: 4,
      showSymbol: true,
      symbolSize: 5,
      symbol: "circle",
      smooth: true,
      areaStyle: {
        normal: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: "rgba(42, 130, 228, 0.22)",
            },
            {
              offset: 1,
              color: "rgba(204, 204, 204, 0)",
            },
          ]),
        },
      },
      lineStyle: {
        color: "rgba(42, 130, 228, 1)",
      },
      itemStyle: {
        color: "rgba(42, 130, 228, 1)",
        borderColor: "rgba(42, 130, 228, 1)",
        borderWidth: 1,
      },
      data: [],
      label: {
        show: false, //是否显示
      },
      markLine: {
        silent: true,
        data: [
          {
            // type: "average",
            yAxis: null,
            name: "最高",
            lineStyle: {
              color: "rgba(255, 87, 51, 1)",
              width: 2,
            },
          },
          {
            // type: "average",
            yAxis: null,
            name: "最低",
            lineStyle: {
              color: "rgba(0, 186, 173, 1)",
              width: 2,
            },
          },
        ],
        symbol: ["none", "none"], // 去掉标记线两端的标记
      },
    },
  ],
};
